<template>
  <div class="bg-white p-4 rounded-lg border border-gray-200 shadow-sm flex flex-col justify-between min-h-[120px]">
    <div class="h-14 w-4/5 bg-skeleton-gradient bg-200% animate-skeleton-loading rounded"></div>
    <div class="flex items-center justify-between mt-auto">
      <div class="h-7 w-20 bg-skeleton-gradient bg-200% animate-skeleton-loading rounded"></div>
    </div>
  </div>
</template>